import {
  ACTIVAR_SPINNER_APP,
  // ACTIVAR_SPINNER_ERROR,
  // ACTIVAR_SPINNER_MODAL,
  // ADD_USER_ASIGNADO,
  // CAMBIAR_OBJECT_APP,
  CAMBIAR_STRING_APP,
  DESACTIVAR_SPINNER_APP,
  // DESACTIVAR_SPINNER_ERROR,
  // DESACTIVAR_SPINNER_MODAL,
  // LIMPIAR_ERROR,
  // LIMPIAR_ERROR_MODAL_MENU,
  // LOGIN_SUCCESS_EN_API,
  MOSTRAR_ERROR_APP,
  // MOSTRAR_ERROR,
  // MOSTRAR_ERROR_MODAL,
  // OCULTAR_MODAL,
  // REFRESHING_TOKEN,
  SET_ARTICULO,
  SET_TO_INITIAL_VALUES,
  // TOKEN_REFRESHED,
  UNSET_ARTICULO,
  // VALIDAR_STRING_APP,
} from '../actions/types';

const INITIAL_STATE = {
  status_app: '',
  render_header: true,
  render_descubre: true,
  render_footer: true,
  viene_de_articulo: false,
  cookie_apc: true,
  idioma: 'es',
  menuVisible: false,
  cabecera_subtitulo: '',
  cabecera_titulo: '',
  cabecera_titulo_s: '',
  cabecera_titulo_xs: '',
  sr_only: '',
  articulos_portada: [],
  articulos_skip: 0,
  articulos_limit: 5,
  articulos_cargar_mas: true,
  articulos_filtros: [],
  articulos_jump: false,
  articulo_titulo: '',
  articulo_nombre: '',
  articulo_linkedin: '',
  articulo_slug: '',
  articulo_fecha: '',
  articulo_etiquetas: [],
  articulo_resumen: '',
  articulo_contenido: '',
  error_app: '',
  mostrar_error_app: false,
  spinner_app: false,
  //refreshingTokenPending: false,
  //latitud_usuario: 40.4193344329804,
  //longitud_usuario: -3.693085312843323,
  //latitud_centro_mapa: 40.4193344329804,
  //longitud_centro_mapa: -3.693085312843323,
  //preferencias_usuario: {},
  //usuarios_asignados: [],
  //lugares_guardados: [],
  //rutas_guardadas: [],
  //viajes_status: [],
  //viaje_info: {},
  //status_viaje_activo: {},
  //texto_cancelacion_viaje: '',
  //datos_coche_conductor: {},
  //imagen_trayecto: null,
  //error: '',
  //mostrar_error: false,
  //loading_error: false,
  //mostrar_modal: false,
  //mostrar_modal_dos: false,
  //modal_input: '',
  //modal_input_validado: false,
  //tipo_lugar: 'Favorito',
  //error_modal: '',
  //mostrar_error_modal: false,
  //loading_modal: false,
  //mostrar_menu: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TO_INITIAL_VALUES:
      return { ...state, ...INITIAL_STATE };
    case CAMBIAR_STRING_APP:
      return { ...state, [action.string.prop]: action.string.value };
    case ACTIVAR_SPINNER_APP:
      return { ...state, spinner_app: true };
    case DESACTIVAR_SPINNER_APP:
      return { ...state, spinner_app: false };
    //case CAMBIAR_OBJECT_APP:
    //  return { ...state, [action.object.obj]: { ...state[action.object.obj], [action.object.prop]: action.object.value } };
    //case REFRESHING_TOKEN:
    //  return { ...state, refreshingTokenPending: true };
    //case TOKEN_REFRESHED:
    //  return { ...state, refreshingTokenPending: false };
    //case VALIDAR_STRING_APP:
    //  return { ...state, [action.string.prop]: action.string.value, [action.validacion.prop]: action.validacion.value };
    //case ACTIVAR_SPINNER_ERROR:
    //  return { ...state, loading_error: true };
    //case DESACTIVAR_SPINNER_ERROR:
    //  return { ...state, loading_error: false };
    case MOSTRAR_ERROR_APP:
      return { ...state, error_app: action.error, mostrar_error_app: true, spinner_app: false };
    case SET_ARTICULO:
      return { ...state, articulo_titulo: action.articulo_titulo, articulo_nombre: action.articulo_nombre, articulo_linkedin: action.articulo_linkedin, articulo_slug: action.articulo_slug, articulo_fecha: action.articulo_fecha, articulo_etiquetas: action.articulo_etiquetas, articulo_contenido: action.articulo_contenido, articulo_resumen: action.articulo_resumen };
    case UNSET_ARTICULO:
      return { ...state, articulo_titulo: '', articulo_nombre: '', articulo_linkedin: '', articulo_slug: '', articulo_fecha: '', articulo_etiquetas: [], articulo_contenido: '', articulo_resumen: '' };
    //case MOSTRAR_ERROR:
    //  return { ...state, error: action.error, mostrar_error: true, loading_error: false };
    //case LIMPIAR_ERROR:
    //  return { ...state, error: '', mostrar_error: false };
    //case ACTIVAR_SPINNER_MODAL:
    //  return { ...state, loading_modal: true };
    //case DESACTIVAR_SPINNER_MODAL:
    //  return { ...state, loading_modal: false };
    //case MOSTRAR_ERROR_MODAL:
    //  return { ...state, error_modal: action.error, mostrar_error_modal: true, loading_modal: false };
    //case OCULTAR_MODAL:
    //  return { ...state, mostrar_modal: false, mostrar_modal_dos: false, error_modal: '', mostrar_error_modal: false, loading_modal: false, modal_input: '', modal_input_validado: false };
    //case LOGIN_SUCCESS_EN_API:
    //  return { ...state, ...INITIAL_STATE };
    //case ADD_USER_ASIGNADO:
    //  return { ...state, usuarios_asignados: [action.usuario, ...state.usuarios_asignados] };
    //case LIMPIAR_ERROR_MODAL_MENU:
    //  return { ...state, error: '', mostrar_error: false, loading_error: false, mostrar_modal: false, mostrar_modal_dos: false, error_modal: '', mostrar_error_modal: false, loading_modal: false, mostrar_menu: false };
    default:
      return state;
  }
};
